import { sendPageView, sendEvent } from "js/utils/google-analytics";

// Send download tracking to GA
export const trackDownload = ({ downloadType, photoId }) => {
    const normalizedDownloadType = downloadType?.toLowerCase() || "unknown";
    if (normalizedDownloadType === "unknown") {
        console.error(`Unknown download type for photo ${photoId}`);
    }
    const pageViewPath = `/download/photo/${normalizedDownloadType}/${photoId}/`;
    sendPageView(pageViewPath);
    sendEvent("download", "photo", downloadType);
};
